<template>
  <el-container style="height: 100vh">
    <el-aside width="200px" style="background: #001529">
      <div class="logo">管理后台</div>
      <el-menu
        :default-active="$route.path"
        background-color="#001529"
        text-color="#c9d1d9"
        active-text-color="#409eff"
        router
      >
        <el-menu-item index="/ad-slots"><i class="el-icon-video-camera"></i> 广告位管理</el-menu-item>
        <el-menu-item index="/red-packet-config"><i class="el-icon-present"></i> 红包/福袋配置</el-menu-item>
        <el-menu-item index="/platform-config"><i class="el-icon-wallet"></i> 用户分成比例配置</el-menu-item>
        <el-menu-item index="/referral-config"><i class="el-icon-share"></i> 直推/间推奖励比例配置</el-menu-item>
        <el-menu-item index="/wx-config"><i class="el-icon-chat-dot-round"></i> 微信登录/转账配置</el-menu-item>
        <el-menu-item index="/app-versions"><i class="el-icon-refresh"></i> 版本管理</el-menu-item>
        <el-menu-item index="/users"><i class="el-icon-user"></i> 用户管理</el-menu-item>
        <el-menu-item index="/withdraws"><i class="el-icon-bank-card"></i> 提现申请审核</el-menu-item>
        <el-menu-item index="/withdraw-config"><i class="el-icon-setting"></i> 提现配置</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          border-bottom: 1px solid #eee;
        "
      >
        <span style="font-size: 16px; font-weight: 500">{{ $route.meta.title }}</span>
        <el-button size="small" @click="logout">退出登录</el-button>
      </el-header>
      <el-main style="background: #f5f5f5">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Layout",
  methods: {
    logout() {
      localStorage.removeItem("admin_token");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.logo {
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  font-weight: bold;
}
</style>